// extracted by mini-css-extract-plugin
export default {"Label":"_Label--eaP2U","WhiteLabel":"_WhiteLabel--hRpSb","EmptyLabelIcon":"_EmptyLabelIcon--vOlAX"};